export default __webpack_public_path__ + "static/media/story-SLIDE_1.d1b4839d.jpg";